/**
 * @module events/types/contextMenu
 */

/**
 * @type {string}
 */
export default 'contextmenu'
